import { useState, useEffect, useRef } from 'react';
import {
  useOverlayTriggerState,
  mergeProps,
  DismissButton,
  OverlayContainer,
  useModalOverlay,
  useDialog,
  FocusScope,
} from '@beamery/lib-ds-components';
import { logClientMessage } from '../../api/logger';
import type { CandidateFormIdentifiers } from '../candidate-form-embedded';
import { isEmbeddedIdentifiersObject } from '../../utils/embedded';
import { CandidateFormEmbedded } from '../candidate-form-embedded';
import { Content, PopoverUnderlay } from './embedded-modal.styles';

export const EmbeddedModal = () => {
  const triggerState = useOverlayTriggerState({});
  const [modalFormValues, setModalFormValues] =
    useState<CandidateFormIdentifiers>();

  useEffect(() => {
    window.beamery = {
      openFlow: (opts: unknown) => {
        if (isEmbeddedIdentifiersObject(opts)) {
          const { flowId, flowSlug, companyId, companySlug } = opts;
          setModalFormValues({
            formId: flowId,
            formSlug: flowSlug,
            companyId,
            companySlug,
          });
          triggerState.open();
        } else {
          void logClientMessage({
            value:
              'Embedded modal flow error. Function called with invalid arguments',
          });
        }
      },
    };
  }, [triggerState]);

  const handleClose = () => triggerState.close();

  const overlayRef = useRef<HTMLDivElement>(null);
  const underlayRef = useRef<HTMLDivElement>(null);

  const { dialogProps } = useDialog(
    {
      role: 'dialog',
    },
    overlayRef,
  );
  const { modalProps, underlayProps } = useModalOverlay(
    {
      isDismissable: true,
    },
    triggerState,
    overlayRef,
  );

  if (!triggerState.isOpen) {
    return null;
  }

  return (
    <OverlayContainer>
      <FocusScope restoreFocus autoFocus contain>
        <PopoverUnderlay ref={underlayRef} {...underlayProps}>
          <Content ref={overlayRef} {...mergeProps(modalProps, dialogProps)}>
            <CandidateFormEmbedded
              formId={modalFormValues?.formId}
              formSlug={modalFormValues?.formSlug}
              companyId={modalFormValues?.companyId}
              companySlug={modalFormValues?.companySlug}
              enableScrollbar
              onClose={handleClose}
            />
          </Content>
          <DismissButton onDismiss={handleClose} />
        </PopoverUnderlay>
      </FocusScope>
    </OverlayContainer>
  );
};
